var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A5A5A5",
    d: "M17.714 10.286a7.428 7.428 0 1 0-14.857 0 7.428 7.428 0 0 0 14.857 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M7.143 8.475c0-.418.116-.842.348-1.271.233-.43.572-.785 1.018-1.067.445-.282.965-.423 1.56-.423.552 0 1.04.118 1.462.354.423.235.75.556.98.96.23.406.346.846.346 1.322 0 .374-.066.702-.197.984a3.023 3.023 0 0 1-.469.73c-.18.204-.505.549-.974 1.033a4.33 4.33 0 0 0-.311.36 1.48 1.48 0 0 0-.175.284 1.52 1.52 0 0 0-.088.258 11.23 11.23 0 0 0-.094.452c-.073.458-.3.687-.68.687a.647.647 0 0 1-.5-.224c-.136-.15-.203-.372-.203-.667 0-.37.05-.69.148-.961.1-.271.23-.509.395-.714.163-.204.384-.448.662-.73a12.8 12.8 0 0 0 .529-.558c.109-.125.2-.265.274-.42a1.14 1.14 0 0 0 .112-.501c0-.352-.114-.65-.34-.892-.227-.242-.52-.363-.877-.363-.42 0-.728.122-.926.367-.198.244-.366.604-.503 1.08-.13.497-.375.746-.737.746a.68.68 0 0 1-.54-.261.86.86 0 0 1-.22-.565zm2.788 7.24a.832.832 0 0 1-.608-.262c-.174-.174-.26-.417-.26-.73 0-.277.084-.51.251-.7a.793.793 0 0 1 .617-.284.77.77 0 0 1 .606.284c.164.19.246.423.246.7 0 .309-.086.551-.257.727a.806.806 0 0 1-.595.264z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestion);
export default __webpack_public_path__ + "static/media/icon-question.ff4bda78ea52d2f6b08dac402c5c34e4.svg";
export { ForwardRef as ReactComponent };